// extracted by mini-css-extract-plugin
export const projectsPlaceholder = "index-modules--projectsPlaceholder--LeGsy";
export const projectsLink = "index-modules--projectsLink--X-U_h";